
import { Vue, Component } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import screenfull from 'screenfull';
import { Tooltip } from 'element-ui';
import { IAPPSTATE } from '@/store/state.d';

@Component({
  components: {
    Tooltip,
  },
})
export default class MenuAvatar extends Vue {
  private status: boolean = false;

  private screen: any = screenfull;

  private flag: boolean = false;

  get show() {
    return this.screen.enabled;
  }

  mounted() {
    this.init();
  }

  init() {
    if (this.screen.enabled) this.screen.on('change', () => { this.flag = !this.flag; });
  }

  fullscreen() {
    if (!this.screen.enabled) {
      this.msg('you browser can not work', { icontType: 'warning' });
    } else this.screen.toggle();
  }
}
